import type { Resource } from '../../';
export const cart_couponCodes_rejection_expired: Resource = {"default":"The requested coupon is expired."};
